import type { ReactNode } from "react";
import { PageSectionHeader } from "../../components/ui/PageSectionHeader";
import { cockpitSection, type CockpitSectionId } from "./cockpitSections";

interface Props {
  sectionId: CockpitSectionId;
  children?: ReactNode;
}

export function SectionHeader({ sectionId, children }: Props) {
  const section = cockpitSection(sectionId);
  return (
    <PageSectionHeader
      headingId={section.headingId}
      group={section.group}
      title={section.label}
      description={section.description}
    >
      {children}
    </PageSectionHeader>
  );
}
